<template>
  <div class="introducecard-frame2">
    <div
      v-for="(item, index) in arr"
      :key="index"
      class="introducecard2"
    >
      <div class="introduceImage2">
        <img :src="item.link" alt="" >
      </div>
      <div class="introduceText2">
        <div class="card-title2">
          <h4>{{ item.title }}</h4>
        </div>
        <div class="card-text2">{{ item.content }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Introducecard3',
  props: {
    arr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style scoped>
.introducecard-frame2{
  display: flex;
  /* justify-content: space-evenly; */
  flex-wrap: wrap;
}

.introducecard2 {
  background-color: rgb(255, 255, 255);
  width:590px;
  height:210px;
  display: flex;
  flex-direction: row;
  text-align: center;
  margin: 5px;
  position: relative;
}

.introduceImage2 {
  padding-top: 70px;
  width: 20%;
  padding-left: 30px;
}

.introduceText2 {
  padding: 40px 30px 0 30px;
  width: 80%;
  text-align: left;
}

.introduceButton2 {
  border:1px solid rgba(255,255,255,1);
  background-color: rgba(59, 124, 209, 0.39);
  opacity: 0;
  width:100px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/introducecard3.vue